
import Supplier from "./assets/js/Supplier";

import { BootstrapVue, BootstrapVueIcons, IconsPlugin } from 'bootstrap-vue'
import VueFormWizard from 'vue-form-wizard'
const { default: Vuelidate } = require('vuelidate')
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vue from "vue"
import App from './App.vue'
Vue.prototype.$http = axios;

import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import "./assets/css/styles.css"

//Vue.prototype.$uploadURL = 'http://onboarding-tool.dev.smartbilling.ca/api/upload/'
//Vue.prototype.$apiURL = 'http://onboarding-tool.dev.smartbilling.ca/api/confirm/'
//Vue.prototype.$stateURL = 'http://onboarding-tool.dev.smartbilling.ca/api/country-state/'
//Vue.prototype.$homeURL = 'http://onboarding-tool.dev.smartbilling.ca/'
Vue.prototype.$uploadURL = location.toString().concat('api/upload/')
Vue.prototype.$apiURL = location.toString().concat('api/confirm/')
Vue.prototype.$stateURL = location.toString().concat('api/country-state/')
Vue.prototype.$homeURL = location.toString()
//Vue.prototype.$uploadURL = 'http://ei.local:8888/api/upload/'
//Vue.prototype.$apiURL = 'http://ei.local:8888/api/confirm/'
//Vue.prototype.$stateURL = 'http://ei.local:8888/api/country-state/'
//Vue.prototype.$homeURL = 'http://localhost:8080'

Vue.prototype.$countrystateoptions = [
  { value: null, text: 'Please select a country and state' },
  {
    label: 'Canada',
    options: []
  },
  {
    label: 'United States',
    options: []
  }
]

if ( !location.toString().includes("clearlyip") ) {
  Vue.prototype.$countrystateoptions.push(  {
    label: 'Ireland',
    options: []
  } );
}

//Vue.prototype.$languageoptions = [
//  { value: null, text: 'Please select a language' },
//  { value: 'EN', text: 'English' },
//  { value: 'FR', text: 'French' }
//]

Vue.prototype.$default_lang_code = {'lang_code' : 'EN', 'lang_desc' : 'English'}
Vue.prototype.$french_lang_code = {'lang_code' : 'FR', 'lang_desc' : 'Francais'}

Vue.prototype.$canada_lang_code = [
  {'lang_code' : 'EN', 'lang_desc' : 'English'},
  {'lang_code' : 'FR', 'lang_desc' : 'Francais'}
]

Vue.prototype.$language_options = [
  {'lang_code' : null, 'lang_desc' : 'Please select a language' },
  {'lang_code' : 'EN', 'lang_desc' : 'English'},
  {'lang_code' : 'FR', 'lang_desc' : 'Francais'}
]

Vue.prototype.$currency_options = [
  {'crcy_code' : null, 'crcy_desc' : 'Please select a currency' },
  {'crcy_code' : 'CAD', 'crcy_desc' : 'Canadian Dollar'},
  {'crcy_code' : 'USD', 'crcy_desc' : 'United States Dollar'},
  {'crcy_code' : 'EUR', 'crcy_desc' : 'Euro'}
]

Vue.prototype.$canada_crcy_code = {'crcy_code' : 'CAD', 'crcy_desc' : 'Canadian Dollar'}

Vue.prototype.$usa_crcy_code = {'crcy_code' : 'USD', 'crcy_desc' : 'United States Dollar'}

Vue.prototype.$eur_crcy_code = {'crcy_code' : 'EUR', 'crcy_desc' : 'Euro'}

Vue.prototype.$Suppliers= [
  /*  
  new Supplier(1, 'Accutel', null, true),
  new Supplier(2, 'Allstream/Zayo', null, true),
  new Supplier(3, 'Bell Wireline', null, true),
  new Supplier(4, 'Bell Aliant', null, true),
  new Supplier(5, 'Bell Conference', null, true),
  new Supplier(6, 'Bell Mobility', null, true),
  new Supplier(7, 'Cogeco', null, true),
  new Supplier(8, 'Charitel', null, true),
  new Supplier(9, 'Eastlink', null, true),
  new Supplier(10, 'Fibrenetics', null, true),
  new Supplier(11, 'Fibrenoire', null, true),
  new Supplier(12, 'Frontier Networks', null, true),
  new Supplier(13, 'Global Crossing', null, true),
  new Supplier(14, 'GoDaddy', null, true),
  new Supplier(15, 'Iristel', null, true),
  new Supplier(16, 'Lognet', null, true),
  new Supplier(17, 'Metro Optic', null, true),
  new Supplier(18, 'MetroFax', null, true),
  new Supplier(19, 'Netelligent', null, true),
  new Supplier(20, 'Navigata', null, true),
  new Supplier(21, 'Openface', null, true),
  new Supplier(22, 'Primus', null, true),
  new Supplier(23, 'Rogers Internet', null, true),
  new Supplier(24, 'Rogers Wireless', null, true),
  new Supplier(25, 'Shaw', null, true),
  new Supplier(26, 'Solution Ubity', null, true),
  new Supplier(27, 'Teliphone', null, true),
  new Supplier(28, 'Telus Mobility', null, true),
  new Supplier(29, 'Telus', null, true),
  new Supplier(30, 'Thinktel', null, true),
  new Supplier(31, 'Videotron', null, true),
  new Supplier(32, 'Zero Fail', null, true)
  */
  new Supplier(8, 'Charitel', null, true)
]

Vue.prototype.$Plans= [
    { label: "Cellular / mobile plans", value: "Cellular / mobile plans"},
    { label: "Internet plans", value: "Internet plans"},
    { label: "Telephony or VOIP", value: "Telephony or VOIP"},
    { label: "Utilities (ex. gas, electricity)", value: "Utilities (ex. gas, electricity)"},
    { label: "IoT (Internet of Things)", value: "IoT (Internet of Things)"}                
]

Vue.use(Vuelidate)
Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(IconsPlugin)

Vue.use(VueFormWizard)

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js